import { render, staticRenderFns } from "./answerQuestion.vue?vue&type=template&id=4c9e467e&scoped=true"
import script from "./answerQuestion.vue?vue&type=script&lang=ts"
export * from "./answerQuestion.vue?vue&type=script&lang=ts"
import style0 from "./answerQuestion.vue?vue&type=style&index=0&id=4c9e467e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9e467e",
  null
  
)

export default component.exports